import { NgForOf } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialog as MatDialog, MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { AppRegistrationDTO, createAppRegistration } from 'src/app/interfaces/appRegistration';
import { ProviderDTO } from 'src/app/interfaces/provider';
import { UserDTO } from 'src/app/interfaces/user';
import { AppRegistrationService } from 'src/app/services/app-registration.service';
import { ErrorhandlingService } from 'src/app/services/errorhandling.service';
import { FunctionsService } from 'src/app/services/functions.service';
import { ProviderService } from 'src/app/services/provider.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-app-registration',
  imports: [ MatDatepickerModule, FormsModule, MatLabel, MatFormField, MatOptionModule, MatSelectModule, MatIconModule, MatInputModule, MatButtonModule,
    NgForOf
  ],
  templateUrl: './app-registration.component.html',
  styleUrls: ['./app-registration.component.css'],
})
export class AppRegistrationComponent implements OnInit {

  isLoggedIn: boolean;
  user: UserDTO;
  isOk: boolean;
  appRegistration: AppRegistrationDTO = { id: -1, userId: -1, description: "", clientId: "", clientSecret: "", providerId: -1, provider: "", dueDateClientSecret: null };
  provider: ProviderDTO;
  providers: ProviderDTO[];

  constructor(private tokenStorageService: TokenStorageService, private router: Router, public dialogRef: MatDialogRef<AppRegistrationComponent>, @Inject(MAT_DIALOG_DATA) data,
    private appRegistrationService: AppRegistrationService, private providerService: ProviderService, private errorHandling: ErrorhandlingService, public matDialog: MatDialog,
  public functions: FunctionsService) {
    if (data != null) {
      this.appRegistration = data;
    }
  }

  isAuthorized() {
    this.isLoggedIn = !!this.tokenStorageService.getToken();
    if (this.isLoggedIn) {
      this.user = this.tokenStorageService.getUser();
      this.isOk = true;
    }
    if (!this.isOk) {
      this.router.navigate(['home']);
    }
  }

  ngOnInit(): void {
    this.isAuthorized();
    this.getData();
  }

  async getData() {
    this.providers = await firstValueFrom(this.providerService.getProviders());
    this.removeProviderFromList('Google', this.providers);
  }

  removeProviderFromList(provider: string, providers: ProviderDTO[]) {
    var index = providers.findIndex(x => x.provider == provider);
    if (index > -1) {
      providers.splice(index, 1);
    }
  }

  async save() {
    this.appRegistration.userId = this.user.id;
    const data = await firstValueFrom(this.appRegistrationService.saveAppRegistration(this.appRegistration.id, createAppRegistration(this.user.id, this.appRegistration.description, this.appRegistration.clientId, this.appRegistration.clientSecret, this.appRegistration.providerId, this.appRegistration.dueDateClientSecret)))
      this.dialogRef.close({ data: data });
  }

  info() {
    window.open(environment.baseURL + '/support', '_blank');
    //this.dialogRef.updateSize('1000px', '600px')
  }


}
